import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    follow: () =>
        __('Følg'),
    following: () =>
        __('Følger'),
};
